(() => {
  if (window.beMultiCategoryCounts) return;
  window.beMultiCategoryCounts = true;
  let counts, loading = false;
  function refresh() {
    const rows = document.querySelectorAll('[data-be-multi-category]');
    if (!rows.length) return;
    if (!counts) {
      if (loading) return;
      loading = true;
      (async () => {
        const totals = new Map();
        let pages = 1;
        for (let page = 1; page <= pages; page++) {
          const url = new URL(rows[0].dataset.countUrl, location.origin);
          url.searchParams.set('filter.p.m.custom.categories', 'マルチユース');
          url.searchParams.set('view', 'be-category-membership');
          url.searchParams.set('page', page);
          const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('unavailable');
          const data = await response.json();
          if (data.categories?.length !== 1 || data.categories[0] !== 'マルチユース' || !Array.isArray(data.products) || !Number.isInteger(data.pages)) throw new Error('invalid scope');
          pages = data.pages;
          for (const categories of data.products) for (const name of new Set(categories || [])) totals.set(name, (totals.get(name) || 0) + 1);
        }
        counts = totals;
        refresh();
      })().catch(() => { /* Do not expose unrelated categories on a failed lookup. */ });
      return;
    }
    rows.forEach(row => {
      const count = counts.get(row.dataset.beMultiCategory) || 0;
      const input = row.querySelector('input[type=checkbox]');
      row.hidden = !count && !input?.checked;
      const label = row.querySelector('.facet-checkbox__text');
      const name = label?.querySelector('.facet-checkbox__text-label');
      if (name && label.textContent.trim() !== `${name.textContent.trim()} (${count})`) label.replaceChildren(name, document.createTextNode(` (${count})`));
      const accessible = row.querySelector('.visually-hidden');
      const text = `${row.dataset.beMultiCategory} (${count}アイテム)`;
      if (accessible && accessible.textContent !== text) accessible.textContent = text;
    });
  }
  new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', event => { if (event.persisted) { counts = undefined; loading = false; } refresh(); });
  refresh();
})();
